<div class="row">
  <div class="col-lg-12">
    <a routerLink="/onon">
      <button class="btn btn-outline-primary mb-4"><span class="fa-light fa-angle-left fa-fw"
      aria-hidden="true"></span>{{'BACK' |translate}}</button>
    </a>
  </div>
</div>
<div class="row">
  <div class="col-lg-12">
    <div>
      <strong>{{'SELECT_CAMERA' |translate}}</strong>
    </div>
    <div class="btn-group mt-2" role="group">
      @for (camera of cameras; track camera) {
        <button type="button" class="btn btn-light"
          [ngClass]="{'activeCamera' : selectedCameraId === camera.id}" (click)="changeCamera(camera.id)"><span
        class="fa-light fa-fw fa-camera-home"></span> {{camera.name}}</button>
      }
    </div>
  </div>
</div>
<hr>
  @if (snapshotBase64 && selectedCameraId) {
    <div class="row">
      @if (snapShotLoaded) {
        <div class="col-lg-6">
          <div class="zoneList">
            <strong>{{'ACTIVE_ZONES' |translate}}</strong>
            @for (zone of allZones; track zone) {
              <div (click)="editZone(zone)" class="mt-2">
                @if (zone.id) {
                  <div class="alert cursorPointer zoneBlock" [ngClass]="zone.type">
                    @if (!zone.toBeDeleted) {
                      <div>
                        <span class="fa-light fa-fw" [ngClass]="getZoneIcon(zone.type)"></span> {{'ZONE_' +
                        zone.type.toUpperCase() |translate}}
                        <div class="float-right">
                          @if (zone.modified) {
                            <span matTooltip="{{'SAVE_ZONE' |translate}}"
                            class="fa-light fa-lg fa-fw fa-floppy-disk mr-1" (click)="saveZone(zone)"></span>
                          }
                          @if (zone.modified) {
                            <span matTooltip="{{'CANCEL_ZONE_EDIT' |translate}}"
                              class="fa-light fa-lg fa-fw fa-xmark mr-4"
                            (click)="cancelZoneEdit(zone); $event.stopPropagation()"></span>
                          }
                          @if (selectedZone === zone && !zone.modified) {
                            <span matTooltip="{{'DELETE_ZONE' |translate}}"
                              class="fa-light fa-fw fa-trash-alt fa-lg"
                            (click)="zone.toBeDeleted = true; $event.stopPropagation()"></span>
                          }
                        </div>
                      </div>
                    }
                    @if (zone.toBeDeleted) {
                      <div>
                        {{'CONFIRM_ZONE_DELETE' |translate}}
                        <span class="fa-light fa-fw fa-lg fa-check ml-2"
                        (click)="deleteZone(zone); $event.stopPropagation()"></span>
                        <span class="fa-light fa-fw fa-lg fa-xmark ml-2"
                        (click)="zone.toBeDeleted = false; $event.stopPropagation()"></span>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
          <div class="zoneContainer" #dragBounds>
            @if (snapshotBase64) {
              <img [src]="snapshotBase64" />
            }
            <svg class="zonesSvg" (click)="svgClick($event)">
              @for (zone of allZones; track zone) {
                <polygon class="zonePolygon" [ngClass]="zone.type"
                  [attr.points]="zone.polygonPoints" (click)="editZone(zone)" />
              }
            </svg>
            @for (xy of selectedZone?.cornerPoints; track xy; let i = $index) {
              <div class="zonePoint" ngDraggable [bounds]="dragBounds" [inBounds]="true" [preventDefaultEvent]="true"
                (movingOffset)="onMoving($event, i)"
              [ngStyle]="{'left.px': xy.x, 'top.px': xy.y}"></div>
            }
          </div>
          <div class="addZoneContainer">
            <strong>{{'ADD_NEW_ZONE' |translate}}</strong>
            <div class="form-group mt-3">
              <mat-form-field>
                <mat-label>{{'ZONE_TYPE' |translate}}</mat-label>
                <mat-select [(ngModel)]="newZone.type">
                  @for (type of zoneTypeList; track type) {
                    <mat-option [value]="type" name="newZoneType">
                      <span class="fa-light fa-fw" [ngClass]="getZoneIcon(type)"></span> {{'ZONE_' +
                      type.toUpperCase() |translate}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-group">
              <button [disabled]="!newZone.type" class="btn btn-primary"
                (click)="zoneDrawingActive = true; selectedZone = null"><span
              class="fa-light fa-fw fa-pencil"></span> {{'DRAW_ZONE' |translate}}</button>
            </div>
            @if (zoneDrawingActive) {
              <div>
                <div>
                  <p>{{'ZONE_DRAWING_INFO' |translate}}</p>
                </div>
                <div class="form-group">
                  <button class="btn btn-outline-primary" (click)="undoLastNewZoneCorner()"><span
                  class="fa-light fa-fw fa-arrow-rotate-left"></span> {{'UNDO_LAST_CORNER'
                |translate}}</button>
              </div>
              <div class="form-group">
                <button class="btn btn-primary" (click)="saveNewZone()"><span
                class="fa-light fa-fw fa-floppy-disk"></span> {{'SAVE' |translate}}</button>
                <button class="btn btn-outline-danger ml-3" (click)="cancelNewZoneDrawing()"><span
                class="fa-light fa-fw fa-xmark"></span> {{'CANCEL' |translate}}</button>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (snapShotLoaded) {
      <div class="col-lg-6 border-left pl-4">
        <div>
          <strong>{{'ALERT_BACKGROUND_IMAGE' |translate }}</strong>
        </div>
        <div class="mt-3">
          <button type="button" class="btn btn-outline-primary ml-2"
          (click)="setBackgroundImage()">{{'SET_ALERT_BACKGROUND' |translate}}</button>
          <button type="button" class="btn btn-outline-danger ml-2"
          (click)="deleteBackgroundImage()">{{'DELETE_ALERT_BACKGROUND' |translate}}</button>
        </div>
        <div class="mt-3">
          <strong>{{'CURRENT_ALERT_BACKGROUND' |translate}}</strong>
          <div class="mt-2">
            @if (alertBackgroundImageBaseLoaded && alertBackgroundImageBase64) {
              <img
                [src]="alertBackgroundImageBase64" />
            }
            @if (alertBackgroundImageBaseLoaded && !alertBackgroundImageBase64) {
              <span>{{'ALERT_BACKGROUND_NOT_SET'
              |translate}}</span>
            }
          </div>
        </div>
      </div>
    }
    <!--Error if snapshot could not be loaded-->
    @if (!snapshotBase64 && snapShotLoaded) {
      <div class="col-lg-4">
        {{'SNAPSHOT_NOT_LOADED' |translate}}
      </div>
    }
    <!--Loading icon while zone information and snapshot is being loaded-->
    @if (!allZones && allZones.length == 0) {
      <div class="col-lg-12">
        <img class="fadeLoader centerLoader logoSmall" src="assets/img/loading_logo.svg">
      </div>
    }
  </div>
}
